import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../components/Converter";
import PlusIcon from "../../../../../components/Icons/PlusIcon";
import RenderFor, { BM_TYP } from "../../../../../components/RenderFor";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { DRUCKPFAHL, ZUGPFAHL } from "../../../../../constants";

export default function PartialSafetyFactor({ value, loadDirection, showModal }) {
  const { t } = useTranslation("translation");
  const indicesSubvalue =
    loadDirection === DRUCKPFAHL ? "s" : loadDirection === ZUGPFAHL ? "s,t" : "";
  return (
    <RowBody
      titleValue={<p>{t("lvText.positionTestLoads.partialSafetyFactor")}</p>}
      indicesValue={
        <span>
          γ<sub>{indicesSubvalue}</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(value, 2)}</span>}
      formulaValue={
        <RenderFor types={[BM_TYP.EUROCODE_7, BM_TYP.GERMANY]}>
          <span className="input--formula" onClick={() => showModal(true)}>
            <PlusIcon />
          </span>
        </RenderFor>
      }
    />
  );
}
